import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule, Routes } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { CoreModule } from '@sla-ng/core';
import { GenericSelectInputModule } from '@sla-ng/ui-material';
import { JoinCostTypeCostCenterDialogModule } from './join-cost-type-cost-center-dialog/join-cost-type-cost-center-dialog.module';
import { JoinCostTypeCostCenterPage } from './join-cost-type-cost-center.page';

export  * from './join-cost-type-cost-center.page';
export  * from './join-cost-type-cost-center-dialog/join-cost-type-cost-center-dialog.module';

const routes: Routes = [
    {
        path: '',
        component: JoinCostTypeCostCenterPage,
    },
];

@NgModule({
    declarations: [ JoinCostTypeCostCenterPage ],
    imports: [
        CommonModule,
        RouterModule.forChild(routes),
        MatTableModule,
        MatIconModule,
        MatCheckboxModule,
        MatCardModule,
        MatListModule,
        FormsModule,
        CoreModule,
        MatInputModule,
        MatSortModule,
        MatProgressBarModule,
        JoinCostTypeCostCenterDialogModule,
        MatSelectModule,
        TranslateModule,
        MatButtonModule,
        GenericSelectInputModule,
        JoinCostTypeCostCenterDialogModule,
        ReactiveFormsModule,
        MatPaginatorModule,
        MatTooltipModule,
    ],
})
export class JoinCostTypeCostCenterPageModule {
}
